<script>
export default {
  name: "GNumInput",
  props: {
    label: {
      type: String,
      default: null
    },
    labelType: {
      default: 1
    },
    value: {
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      val: this.value
    };
  },
  mounted() {},
  computed: {
    msgType() {
      return this.chkVal();
    },
    msgTx() {
      let v = this.val;
      let r = this.msgType;
      if (r == -2) return "" + v + "<" + this.min;
      else if (r == -1) return "" + v + ">" + this.max;
      return null;
    }
  },
  methods: {
    chkVal() {
      let v = this.val,
        min = this.min,
        max = this.max;
      if (min != null && v < min) return -2;
      if (max != null && v > max) return -1;
      return 0;
    },
    evInp() {
      let c = this.chkVal();
      if (c == 0) this.$emit("input", this.val);
    }
  }
};
</script>
<template>
  <b-field
    :label="label"
    :label-position="labelType == 1 ? 'on-border' : ''"
    :message="msgTx"
    :type="msgType != 0 ? 'is-warning' : ''"
  >
    <b-input type="number" v-model="val" @input="evInp"></b-input>
  </b-field>
</template>
